const features = [
  {
    icon: 'ri-global-line',
    title: '多平台聚合',
    desc: '整合妖精视频、桃花视频、苹果视频、榴莲视频等50+视频平台资源，一站直达。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '热门视频合集每日精选更新，紧跟各平台最新发布，不错过任何好内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '高清画质',
    desc: '精选高清资源占比达99%，流畅播放体验，支持多种清晰度自由切换。',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '影视大全',
    desc: '覆盖多元主题分类，从热门视频到冷门佳作，影视大全应有尽有。',
  },
  {
    icon: 'ri-thumb-up-line',
    title: '精选合集',
    desc: '人工精选+智能推荐，热门视频合集优质内容精准触达目标用户需求。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">平台优势</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              为什么选择青青草视频作为您的影视大全与热门视频合集平台
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="group rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-primary-200/60 transition-all duration-300 text-center"
              >
                <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${feat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900">{feat.title}</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}